module.exports = {
      id: "vikatan-tv-usage",
      viewBox: "0 0 213 43",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#vikatan-tv",
      toString: function () {
        return this.url;
      }
    }